/* MEILORA free gift popup - 2026-06-20 */
(function () {
  if (window.__meiloraFreeGiftPopupReady) return;
  window.__meiloraFreeGiftPopupReady = true;
  window.__meiloraFreeGiftPopup = true;

  var THRESHOLD = 5000;
  var STORAGE_KEY = "meilora_gift_popup_dismissed_cart";
  var GIFT_PROPERTY = "_meilora_gift";
  var GIFTS = [
    {
      variantId: 44970173890710,
      title: "Ewige Linie Kette",
      variant: "",
      image: "https://cdn.shopify.com/s/files/1/0675/6161/9606/files/72.jpg?v=1747195215",
      compareAt: "51,00 EUR"
    },
    {
      variantId: 44940914458774,
      title: "Gedrehte Eleganz Kette",
      variant: "Gold",
      image: "https://cdn.shopify.com/s/files/1/0675/6161/9606/files/59_1.jpg?v=1744900279",
      compareAt: "51,00 EUR"
    },
    {
      variantId: 44931741876374,
      title: "Filigrane Doppelhelix",
      variant: "Gold",
      image: "https://cdn.shopify.com/s/files/1/0675/6161/9606/files/4-23.jpg?v=1744643411",
      compareAt: "54,00 EUR"
    },
    {
      variantId: 45948643934358,
      title: "Wide Sleek Kette",
      variant: "",
      image: "https://cdn.shopify.com/s/files/1/0675/6161/9606/files/KE0467G.jpg?v=1764954188",
      compareAt: "60,00 EUR"
    }
  ];

  function giftIds() {
    return GIFTS.map(function (gift) { return gift.variantId; });
  }

  function formatMoney(cents) {
    return (Math.max(0, cents) / 100).toFixed(2).replace(".", ",") + " EUR";
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (response) {
      return response.json();
    });
  }

  function paidSubtotal(cart) {
    var ids = giftIds();
    return (cart.items || []).reduce(function (sum, item) {
      return ids.indexOf(item.variant_id) > -1 ? sum : sum + item.final_line_price;
    }, 0);
  }

  function selectedGift(cart) {
    var ids = giftIds();
    return (cart.items || []).find(function (item) {
      return ids.indexOf(item.variant_id) > -1;
    });
  }

  function cartSignature(cart) {
    return String((cart.items || []).map(function (item) {
      return item.variant_id + ":" + item.quantity;
    }).join("|"));
  }

  function addCss() {
    if (document.getElementById("meilora-free-gift-popup-css")) return;
    var css = [
      ".ml-gift-trigger{width:100%;border:1px solid #111;background:#fff;color:#111;min-height:42px;padding:10px 14px;margin:12px 0;font:700 13px/1.2 inherit;letter-spacing:.02em;cursor:pointer}",
      ".ml-gift-trigger:hover{background:#111;color:#fff}",
      ".ml-gift-modal{position:fixed;inset:0;z-index:2147483000;display:none;align-items:center;justify-content:center;padding:18px;background:rgba(0,0,0,.58)}",
      ".ml-gift-modal.is-open{display:flex}",
      ".ml-gift-dialog{position:relative;width:min(860px,100%);max-height:min(82vh,760px);overflow:hidden;background:#fff;border-radius:10px;box-shadow:0 20px 70px rgba(0,0,0,.25);color:#111}",
      ".ml-gift-close{position:absolute;top:12px;right:12px;width:34px;height:34px;border:0;background:#fff;font-size:28px;line-height:1;cursor:pointer;z-index:2}",
      ".ml-gift-head{text-align:center;padding:24px 52px 12px}",
      ".ml-gift-head h2{margin:0;font-size:28px;line-height:1.15;font-weight:800;letter-spacing:.01em}",
      ".ml-gift-head p{display:inline-block;margin:14px 0 0;padding:7px 12px;border-radius:8px;background:#ffe889;font-size:14px;line-height:1.25;font-weight:700}",
      ".ml-gift-list{display:grid;grid-auto-flow:column;grid-auto-columns:minmax(162px,1fr);gap:12px;margin:0 20px 20px;padding:20px;overflow-x:auto;background:#f6f6f4;border-radius:8px;scroll-snap-type:x proximity}",
      ".ml-gift-card{scroll-snap-align:start;display:flex;flex-direction:column;min-height:330px;background:#fff;border:1px solid #e8e4df;border-radius:7px;overflow:hidden;text-align:center}",
      ".ml-gift-card img{width:100%;aspect-ratio:1/1;object-fit:cover;background:#faf8f6}",
      ".ml-gift-card__body{display:flex;flex:1;flex-direction:column;padding:12px;gap:8px}",
      ".ml-gift-card h3{margin:0;font-size:14px;line-height:1.25;font-weight:800;min-height:36px}",
      ".ml-gift-card small{min-height:16px;color:#9a918a;font-size:12px;line-height:1.2;text-transform:uppercase}",
      ".ml-gift-price{margin-top:auto;font-size:13px;font-weight:800;color:#e24a4a}",
      ".ml-gift-price s{margin-left:6px;color:#555;font-weight:500}",
      ".ml-gift-card button{width:100%;min-height:38px;border:0;border-radius:6px;background:#111;color:#fff;font:800 13px/1.2 inherit;cursor:pointer}",
      ".ml-gift-card button[disabled]{opacity:.6;cursor:wait}",
      ".ml-gift-card.is-selected{box-shadow:0 0 0 2px #111 inset}",
      ".ml-gift-card.is-selected button{background:#555}",
      ".ml-gift-toast{position:fixed;left:50%;bottom:24px;z-index:2147483001;transform:translateX(-50%) translateY(20px);opacity:0;pointer-events:none;background:#111;color:#fff;padding:10px 14px;border-radius:999px;font-size:13px;transition:opacity .2s ease,transform .2s ease}",
      ".ml-gift-toast.is-visible{opacity:1;transform:translateX(-50%) translateY(0)}",
      "@media(max-width:640px){.ml-gift-modal{align-items:flex-end;padding:0}.ml-gift-dialog{width:100%;max-height:88vh;border-radius:14px 14px 0 0}.ml-gift-head{padding:22px 48px 10px}.ml-gift-head h2{font-size:23px}.ml-gift-list{grid-auto-columns:66%;margin:0 12px 16px;padding:12px}.ml-gift-card{min-height:300px}}"
    ].join("");
    var style = document.createElement("style");
    style.id = "meilora-free-gift-popup-css";
    style.textContent = css;
    document.head.appendChild(style);
  }

  function ensureModal() {
    addCss();
    var existing = document.querySelector("[data-ml-gift-modal]");
    if (existing) return existing;
    var modal = document.createElement("div");
    modal.className = "ml-gift-modal";
    modal.setAttribute("data-ml-gift-modal", "");
    modal.setAttribute("role", "dialog");
    modal.setAttribute("aria-modal", "true");
    modal.innerHTML = [
      "<div class='ml-gift-dialog'>",
      "<button class='ml-gift-close' type='button' aria-label='Close' data-ml-gift-close>&times;</button>",
      "<div class='ml-gift-head'><h2>Select your free gift!</h2><p>You can add 1 gift product(s)</p></div>",
      "<div class='ml-gift-list' data-ml-gift-list></div>",
      "</div>"
    ].join("");
    modal.addEventListener("click", function (event) {
      if (event.target === modal || event.target.closest("[data-ml-gift-close]")) closeModal(true);
    });
    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape") closeModal(true);
    });
    document.body.appendChild(modal);
    return modal;
  }

  function renderGiftCards(cart) {
    var current = selectedGift(cart);
    var list = ensureModal().querySelector("[data-ml-gift-list]");
    list.innerHTML = GIFTS.map(function (gift) {
      var active = current && current.variant_id === gift.variantId;
      return [
        "<article class='ml-gift-card" + (active ? " is-selected" : "") + "'>",
        "<img src='" + gift.image + "' alt=''>",
        "<div class='ml-gift-card__body'>",
        "<h3>" + gift.title + "</h3>",
        "<small>" + (gift.variant || "&nbsp;") + "</small>",
        "<div class='ml-gift-price'>0,00 EUR <s>" + gift.compareAt + "</s></div>",
        "<button type='button' data-ml-gift-add='" + gift.variantId + "'>" + (active ? "Selected" : "Add to cart") + "</button>",
        "</div>",
        "</article>"
      ].join("");
    }).join("");
  }

  function openModal(cart) {
    renderGiftCards(cart);
    ensureModal().classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
  }

  function closeModal(remember) {
    var modal = document.querySelector("[data-ml-gift-modal]");
    if (modal) modal.classList.remove("is-open");
    document.documentElement.style.overflow = "";
    if (remember) {
      getCart().then(function (cart) {
        try { sessionStorage.setItem(STORAGE_KEY, cartSignature(cart)); } catch (error) {}
      });
    }
  }

  function showToast(message) {
    var toast = document.querySelector(".ml-gift-toast");
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "ml-gift-toast";
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add("is-visible");
    setTimeout(function () { toast.classList.remove("is-visible"); }, 2200);
  }

  function removeGiftLines(cart) {
    var ids = giftIds();
    var lines = (cart.items || []).filter(function (item) {
      return ids.indexOf(item.variant_id) > -1;
    });
    return lines.reduce(function (promise, item) {
      return promise.then(function () {
        return fetch("/cart/change.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
      });
    }, Promise.resolve());
  }

  function selectGift(variantId, button) {
    if (button) {
      button.disabled = true;
      button.textContent = "...";
    }
    var fallbackReload = setTimeout(function () {
      if (button && button.disabled && location.pathname.indexOf("/cart") === 0) {
        location.reload();
      }
    }, 6000);
    getCart()
      .then(function (cart) {
        if (paidSubtotal(cart) < THRESHOLD) throw new Error("threshold");
        return removeGiftLines(cart);
      })
      .then(function () {
        return fetch("/cart/add.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: { "_meilora_gift": "Select your free gift!" }
          })
        });
      })
      .then(function () { return getCart(); })
      .then(function (cart) {
        try { sessionStorage.setItem(STORAGE_KEY, cartSignature(cart)); } catch (error) {}
        renderGiftCards(cart);
        closeModal(false);
        showToast("Free gift added to cart.");
        refreshThemeCart(cart);
      })
      .catch(function () {
        showToast("Please keep your cart above 50 EUR.");
      })
      .finally(function () {
        clearTimeout(fallbackReload);
        if (button) button.disabled = false;
      });
  }

  function refreshThemeCart(cart) {
    document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
    if (typeof window.buildCart === "function") {
      try { window.buildCart(cart, true); } catch (error) {}
    }
    setTimeout(function () { injectGiftTrigger(cart); }, 350);
    setTimeout(function () { injectGiftTrigger(cart); }, 1200);
  }

  function isCartOpen() {
    return document.body.classList.contains("side_Drawer_open") ||
      document.body.classList.contains("yv_side_Drawer_open") ||
      location.pathname.indexOf("/cart") === 0;
  }

  function cartRoot() {
    return document.querySelector("#mini__cart [data-drawer-body] .yv-cart-drawer") ||
      document.querySelector("#mini__cart [data-drawer-body]") ||
      document.querySelector("[data-drawer-body] .yv-cart-drawer") ||
      document.querySelector("form[action*='/cart']") ||
      document.querySelector("main");
  }

  function insertBeforeFooter(root) {
    return root.querySelector(".cart-drawer-bottom, .cart-drawer-footer, .yv-cart-footer, .cart-footer, .cart-summary, [data-cart-total], [data-checkout-wrapper], .checkout-btn");
  }

  function injectGiftTrigger(cart) {
    if (!isCartOpen()) return;
    var root = cartRoot();
    if (!root) return;
    cleanupMisplacedGiftText(root);
    var subtotal = paidSubtotal(cart);
    var gift = selectedGift(cart);
    var old = root.querySelector("[data-ml-gift-trigger-wrap]");
    if (subtotal < THRESHOLD || gift) {
      if (old) old.remove();
      return;
    }
    if (!old) {
      old = document.createElement("div");
      old.setAttribute("data-ml-gift-trigger-wrap", "");
      var before = insertBeforeFooter(root);
      if (before && before.parentNode === root) root.insertBefore(old, before);
      else root.appendChild(old);
    }
    old.innerHTML = [
      "<button class='ml-gift-trigger' type='button' data-ml-gift-open>",
      "Select your free gift!",
      "</button>"
    ].join("");
  }

  function cleanupMisplacedGiftText(root) {
    var ids = giftIds();
    var cartGiftTitles = GIFTS.map(function (gift) { return gift.title; });
    Array.prototype.slice.call(root.querySelectorAll("span, p, small, div")).forEach(function (el) {
      var text = (el.textContent || "").trim();
      if (!/选择您的免费礼品|Select your free gift|free gift/i.test(text)) return;
      var row = el.closest("[data-line], .cart-item, .yv-cart-product-box, .cart__item, li");
      var rowText = row ? row.textContent || "" : "";
      var isGiftRow = cartGiftTitles.some(function (title) { return rowText.indexOf(title) > -1; });
      if (!isGiftRow && text.length < 80) {
        var discountRow = el.closest(".discounts__discount, .coupanName, li");
        if (discountRow) discountRow.style.display = "none";
        el.style.display = "none";
      }
    });
  }

  var checking = false;
  function maybeAutoOpen() {
    if (!isCartOpen()) return;
    var existingModal = document.querySelector("[data-ml-gift-modal].is-open");
    if (existingModal) return;
    if (checking) return;
    checking = true;
    getCart().then(function (cart) {
      injectGiftTrigger(cart);
      var subtotal = paidSubtotal(cart);
      var gift = selectedGift(cart);
      if (subtotal < THRESHOLD) {
        if (gift) removeGiftLines(cart).then(function () { return getCart(); }).then(refreshThemeCart);
        return;
      }
      if (gift) return;
      var sig = cartSignature(cart);
      try {
        if (sessionStorage.getItem(STORAGE_KEY) === sig) return;
      } catch (error) {}
      openModal(cart);
    }).catch(function () {}).finally(function () {
      checking = false;
    });
  }

  document.addEventListener("click", function (event) {
    var open = event.target.closest("[data-ml-gift-open]");
    if (open) {
      event.preventDefault();
      getCart().then(openModal);
      return;
    }
    var add = event.target.closest("[data-ml-gift-add]");
    if (add) {
      event.preventDefault();
      selectGift(Number(add.getAttribute("data-ml-gift-add")), add);
    }
  }, true);

  var timer;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      maybeAutoOpen();
    }, 900);
  }

  document.addEventListener("DOMContentLoaded", schedule);
  document.addEventListener("click", function (event) {
    if (event.target.closest("a[href='/cart'], a[href*='/cart'], [data-drawer-trigger], .cart, .cart-link, .cart-icon, #cart-icon-bubble")) {
      setTimeout(schedule, 900);
    }
  }, true);
  document.addEventListener("cart:refresh", schedule);
  document.addEventListener("cart:updated", schedule);
  schedule();
})();
